<div class="sam-margin-right sam-form-flex-row border-box" [ngClass]="showWarning ? 'k-bg-warning' : ''">
   <fa-icon
      [ngClass]="[
         fadeIconOpacity ? 'sam-margin sam-center input-icon icon-fade-opacity' : 'sam-margin sam-center input-icon',
         swapIconOpacity ? 'sam-margin sam-center input-icon icon-swap-opacity' : 'sam-margin sam-center input-icon',
         highlightIcon ? 'sam-margin sam-center input-icon sam-accent-color' : 'sam-margin sam-center input-icon'
      ]"
      [icon]="icon"
   ></fa-icon>

   <div [ngClass]="disabled ? 'sam-pointer-disabled input-field' : 'input-field'">
      <div class="k-form-field k-form-field-with-icon">
         <ng-container *ngIf="isFocused; else no_auto_focus">
            <ng-container [ngTemplateOutlet]="auto_focus"></ng-container>
         </ng-container>
         <fa-icon
            *ngIf="value?.length > 0 && !disabled && !useAutocomplete"
            class="clear-search-text-icon sam-margin-right"
            [icon]="clearFilterIcon"
            (click)="clearText()"
         >
         </fa-icon>
      </div>
   </div>
</div>

<ng-template #auto_focus>
   <ng-container *ngIf="useAutocomplete">
      <kendo-multiselect
         #multiselect
         [data]="autocompleteMatches"
         placeholder="{{ header | translate }}"
         samwebAutoFocus
         [disabled]="disabled"
         fxFlex="1 1 auto"
         (debouncedInput)="textChangedDebounced($event.target.value)"
         (input)="textChanged($event.target.value)"
         [(ngModel)]="selectedEntries"
         [allowCustom]="true"
         (valueChange)="onMultiselectValueChange($event)"
         (focusout)="onFocusOut($event)"
      >
      </kendo-multiselect>
   </ng-container>
   <ng-container *ngIf="!useAutocomplete">
      <input
         placeholder="{{ header | translate }}"
         samwebAutoFocus
         [disabled]="disabled"
         class="text-box"
         fxFlex="1 1 auto"
         (input)="textChanged($event.target.value)"
         (debouncedInput)="textChangedDebounced($event.target.value)"
         [value]="value"
         kendoTextBox
      />
   </ng-container>
</ng-template>

<ng-template #no_auto_focus>
   <ng-container *ngIf="useAutocomplete">
      <kendo-multiselect
         #multiselect
         [data]="autocompleteMatches"
         placeholder="{{ header | translate }}"
         [disabled]="disabled"
         fxFlex="1 1 auto"
         (debouncedInput)="textChangedDebounced($event.target.value)"
         (input)="textChanged($event.target.value)"
         [(ngModel)]="selectedEntries"
         [allowCustom]="true"
         (valueChange)="onMultiselectValueChange($event)"
         (focusout)="onFocusOut($event)"
      >
      </kendo-multiselect>
   </ng-container>
   <ng-container *ngIf="!useAutocomplete">
      <input
         placeholder="{{ header | translate }}"
         [disabled]="disabled"
         class="text-box"
         fxFlex="1 1 auto"
         (input)="textChanged($event.target.value)"
         (debouncedInput)="textChangedDebounced($event.target.value)"
         [value]="value"
         kendoTextBox
      />
   </ng-container>
</ng-template>
